import type { ReactNode } from "react";

interface P { title: string; action?: ReactNode; children: ReactNode }

export function SectionShelf({ title, action, children }: P) {
  return (
    <section style={{ marginBottom: 28 }}>
      <div className="row" style={{ justifyContent: "space-between", marginBottom: 14 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>{title}</h2>
        {action}
      </div>
      <div className="shelf">{children}</div>
    </section>
  );
}
